import React from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { wacToken } from "@/libraries/design/foundations/index.ts";

export const Disclaimer = () => {
    const intl = useIntl();
    return (
        <div css={containerCss}>
            <p css={textCss}>
                {intl.formatMessage({
                    id: "StrategyCollectionPriceFinder.disclaimer",
                    defaultMessage:
                        "This estimate isn’t binding for either you or Atlassian. Figures shown here are intended to show an estimation of the final price, not the cost after taxes and other potential changes."
                })}
            </p>
        </div>
    );
};

const containerCss = css({
    "@media (min-width: 1024px)": {
        maxWidth: "384px"
    }
});

const textCss = css({
    fontWeight: "400",
    lineHeight: "20px",
    fontSize: "14px",
    color: wacToken("color.primary.black")
});
